import React, { useState, useEffect } from "react";
import './ShipmentList.scss';
import { Button, Pagination, Tag, message } from 'antd';
import ShipmentDetails from "../ShipmentDetails/ShipmentDetails";
import { exportShipmentsCSV, pollTrackingShipment } from "../../services/shipments";
import CollapseList from "../CollapseList/CollapseList";
import ShipmentListTable from "./ShipmentListTable/ShipmentListTable";

const PER_PAGE = 25;

const ShipmentList = ({ shipments, updates, page, setPage, totalPages, refetch, selectedShipment, selectShipment, clearSelectedShipment, filters, onShowNowlunForm }) => {
  const [fetchingShipments, setFetchingShipments] = useState([])

  useEffect(() => {
    setFetchingShipments(shipments.filter(shipment => shipment.fetch))
  }, [shipments])

  useEffect(() => {
    const intervals = [];
    fetchingShipments.forEach((fetchingShipment) => {
      if (process.env.REACT_APP_ENV !== 'development') {
        const intervalId = setInterval(async () => {
          const res = await pollTrackingShipment(fetchingShipment.id)
          if (!res.data?.shipment?.fetch) {
            setFetchingShipments(fetchingShipments.filter((fetchShipment) => fetchShipment.id !== fetchingShipment.id));
            refetch();
          }
        }, 1000 * 10);
        intervals.push(intervalId)
      }
    })
    return () => { intervals.forEach(interval => clearInterval(interval)) }
  }, [fetchingShipments])

  const openAddShipment = () => {
    window.dispatchEvent(new Event('track'));
  }

  const tagSummary = (tags, expand = false) => {
    if (expand) {
      return <>
        {tags[0] && (<Tag className="tag" color="#DADCE0">{tags[0]}</Tag>)}
        {tags[1] && (<Tag className="tag" color="#DADCE0">+{tags.length - 1}</Tag>)}
      </>
    }
    return (<Tag className="tag" color="#DADCE0">+{tags.length}</Tag>)
  }

  const exportShipments = async() => {
    try {
      const response = await exportShipmentsCSV({...filters});
      const blob = new Blob([response.data]);
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = response.headers['content-disposition'].split("'").pop();
      link.click();
      URL.revokeObjectURL(url); // Clean up after download
      message.success('Exported Successfully');
    } catch(e) {
      message.error('Export Failed.');
    }
  }


  return (
    // antd table click action on table cell
    <div className="ShipmentList">
      <div className="list-wrapper">
        <div className="header">
          <div>My Shipments</div>
          <div>
            <Button className="link-btn archive-btn" onClick={exportShipments}>
              Export
            </Button>
          </div>
        </div>
        {shipments.length
          ?
          <div className="elements">
            <div className="elements-table">
              <ShipmentListTable 
                shipments={shipments} 
                selectShipment={selectShipment} 
                updates={updates} 
                refetch={refetch} 
                tagSummary={tagSummary}
              />
            </div>
            <div className="elements-card">
              <CollapseList 
                shipments={shipments} 
                updates={updates} 
                selectShipment={selectShipment} 
                refetch={refetch} 
                tagSummary={tagSummary}
              />
            </div>

            {
              totalPages > PER_PAGE &&
              <div className='pagination'>
                <Pagination defaultCurrent={page} total={totalPages} defaultPageSize={PER_PAGE} pageSize={PER_PAGE} showSizeChanger={false} onChange={(page) => setPage(page)} />
              </div>
            }

          </div>
          :
          <div className="no-elements">
            <span>It seems you don't have any shipments, start by adding your shipments <span className="link-btn clickable" onClick={openAddShipment}>here</span></span>
          </div>
        }

        {selectedShipment && <ShipmentDetails 
          shipment={selectedShipment} 
          clearSelectedShipment={clearSelectedShipment} 
          refetch={refetch}
        />}
      </div>
    </div>
  )
}
export default ShipmentList;
